module.exports = __webpack_public_path__ + "static/img/subimit.348adc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paper/subimit.png
// module id = cXH1
// module chunks = 1